import React from 'react';
import PropTypes from 'prop-types';

import {translate} from 'views/module';

import CompactDropdown from './CompactDropdown';

import backend from 'utils/backend';

const BookCallDropdown = (props) => {
  const {label, currentUser, primaryRelationship} = props;

  const [admins, setAdmins] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const fetchAdmins = async () => {
      setLoading(true);

      try {
        const filter = [
          {key: 'status', value: ['ACTIVE']},
          {key: 'role', value: 'ADMIN'},
        ];
        const sortBy = {sortKey: 'createdAt', sortDirection: 'DESC'};
        const result = await backend.user.queryUser(filter, sortBy);

        setAdmins(result.list ?? []);
      } catch (error) {
        console.error('Failed to query admin data');
      } finally {
        setLoading(false);
      }
    };

    fetchAdmins();
  }, []);

  const bookCallLabel = translate('client.ClientDetail.Status.Metrics.BookCall');
  const menuLabel = translate('client.ClientDetail.Status.Metrics.BookWith');

  const getCalendlyLink = (admin) => {
    const adminFirstName = admin?.firstName?.trim().split(/\s+/)[0]?.toLowerCase().replace(/[^a-z0-9-]/g, '');

    if (!adminFirstName) {
      return null;
    }

    const relationshipName = (primaryRelationship?.name ?? '').trim();
    const email = primaryRelationship?.email ?? '';
    const phoneNumber = primaryRelationship?.phoneNumber ?? '';
    const [firstName = '', ...lastNameParts] = relationshipName.split(/\s+/).filter(Boolean);
    const params = new URLSearchParams({
      utm_term: primaryRelationship?.relationshipRn ?? '',
      location: phoneNumber,
      name: relationshipName,
      email,
      utm_source: email,
      first_name: firstName,
      last_name: lastNameParts.join(' '),
    });

    return `https://calendly.com/${adminFirstName}-carequilt?${params.toString()}`;
  };
  const currentUserCalendlyLink = getCalendlyLink(currentUser);

  return (
    <CompactDropdown
      getOptionHref={getCalendlyLink}
      getOptionKey={(admin) => admin.userRn}
      getOptionLabel={(admin) => `${admin.firstName} ${admin.lastName || ''}`.trim()}
      label={label}
      loading={loading}
      menuLabel={menuLabel}
      options={admins}
      value={bookCallLabel}
      valueColor='#DA7955'
      valueHref={currentUserCalendlyLink}
    />
  );
};

BookCallDropdown.propTypes = {
  currentUser: PropTypes.object,
  label: PropTypes.string,
  primaryRelationship: PropTypes.object,
};

export default BookCallDropdown;
